import React from "react";
import {
  Datagrid,
  TextField,
  List,
  ResourceComponentProps,
  Filter,
  DateField,
  ReferenceInput,
  AutocompleteInput,
  ReferenceField,
  FunctionField,
} from "react-admin";
import { printUser } from "../../helpers/print-user";

export const BookableAvailabilitiesList = (props: ResourceComponentProps) => (
  <List
    {...props}
    bulkActionButtons={false}
    pagination={false}
    filters={
      <Filter {...props}>
        <ReferenceInput
          label="Client"
          reference="User"
          source="clientId"
          filterToQuery={(q: string) => ({ q })}
        >
          <AutocompleteInput optionText={printUser} />
        </ReferenceInput>
      </Filter>
    }
  >
    <Datagrid>
      <TextField source="id" />
      <DateField source="start" showTime />
      <DateField source="end" showTime />
      <ReferenceField label="Agent" reference="User" source="agent.id">
        <FunctionField render={printUser} />
      </ReferenceField>
    </Datagrid>
  </List>
);
